import { Navigate } from 'react-router-dom';
import DefaultLayout from '../layouts/DefaultLayout';
import LoadingOverlay from '@/components/loading/LoadingOverlay';
import { useAuthContext } from '@/contexts/AuthContext';
import { ConfigProvider } from '@/contexts/ConfigContext';
import { ROUTES } from '@/config/const';

const ProtectedRoutes = () => {
  const { isAuthenticated, isLoading, isRefreshing } = useAuthContext();

  if (isLoading || isRefreshing) {
    return <LoadingOverlay />;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.login} replace />;
  }

  return (
    <ConfigProvider>
      <DefaultLayout />
    </ConfigProvider>
  );
};

export default ProtectedRoutes;
